import React from 'react';
import {
  IonRefresher,
  IonRefresherContent,
  RefresherEventDetail,
} from '@ionic/react';

interface PageRefresherProps {
  onRefresh?: (event: CustomEvent<RefresherEventDetail>) => Promise<void>;
}

const PageRefresher: React.FC<PageRefresherProps> = ({ onRefresh }) => {
  const handleRefresh = async (event: CustomEvent<RefresherEventDetail>) => {
    if (onRefresh) {
      await onRefresh(event);
    } else {
      // Default refresh behavior: reload the page
      await new Promise(resolve => setTimeout(resolve, 1000));
      window.location.reload();
      return; // Return early since we're reloading
    }

    event.detail.complete();

    // After refresh completes, dispatch event to re-check Contact Picker support
    // This allows the app to detect iOS Safari feature flag changes without closing the PWA
    // Use requestAnimationFrame to ensure UI has updated before rechecking
    requestAnimationFrame(() => {
      // eslint-disable-next-line no-console
      console.log('Dispatching recheckContactPicker event');
      window.dispatchEvent(new Event('recheckContactPicker'));
    });
  };

  return (
    <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
      <IonRefresherContent></IonRefresherContent>
    </IonRefresher>
  );
};

export default PageRefresher;
